import React from 'react'
import './Offer.css';
import { Box, Collapse, Icon, List, ListItem,
	ListItemIcon, Stack } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
// import {useTheme} from "@mui/material/styles";
// import CustomDialog from '../modals/CustomDialog'
import { MonetizationOn, Today, TimerOutlined, ArrowRightOutlined } from '@mui/icons-material'
// import moment from 'moment'
// import * as actions from '../../store/actions'
import { connect } from 'react-redux'
import { getProviderLogo } from '../../shared/providerHelper'
import { useNavigate } from 'react-router-dom'
import { RootState } from '../../app/store'
import { Button } from '../form/Button';
import { selectOffer, Offer, setSelectedOffer } from '../../store/actions/offers'
import OfferAmount from './OfferAmount'
import { OfferHelper } from '../../shared/offer-helper'
import OfferDetails from "./OfferDetails";
import {generateTag} from "../../shared/utility";
// import CreateAccount from '../modals/content/CreateAccount'
import moment from 'moment'
import {Types} from '../../shared/matchingClientsHelper'

const orderLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

class ItemDescriptionDto {
	color?: string;
	icon?: any;
	description?: string;
}

class OfferPropsDto {
	offer: any;
	index?: any;
	selectOffer?: any;
	setSelectedOffer?: any;
	loading?: boolean;
	type?: string;
	badge?: string;
}

function OfferComponent(props: OfferPropsDto) {
	// const theme = useTheme()
	// const isTableAndLess = useMediaQuery(theme.breakpoints.down('md'))

	const [open, setOpen] = React.useState(false)
	const [isLoading, setLoading] = React.useState(false);

	const handlerOpen = () => {
		if(!OfferHelper.isOfferExpired(props.offer)) {
			setOpen(!open)
		}
	}

	// const [openModal, setOpenModal] = useState(false)

	// const handleOpenModal = () => {
	// 	setOpenModal(true)
	// }

	// const handleCloseModal = () => {
	// 	setOpenModal(false)
	// }

	// const handleContactAgent = () => {
	// 	handleCloseModal()
	// 	// props.onSendCommentToContactAgent(props.offer)
	// }

	const navigate = useNavigate();
	const onToOffer = () => {
		if (!OfferHelper.canSelectOffer(props.offer)) {
			if (!OfferHelper.canOpenOfferLink(props.offer)) {
				return ;
			}
			props.setSelectedOffer(props.offer);
			navigate('/offer');
			return ;
		}

		setLoading(true);
		props.selectOffer(props.offer, (err: any) => {
			setLoading(false);
			if (err) {
				return ;
			}
			navigate('/offer');
		});
	}

	const controlStyles = {display: 'flex', cursor: 'pointer', fontSize: {xs: '48px'}, color: '#29aae1', marginTop: '-12px'}
	const control = open
		? <KeyboardArrowUpIcon
			sx={controlStyles}
			onClick={handlerOpen}
			id={generateTag(!open ? 'open' : 'close', {prefix: 'offer-card', snippet: props.offer.provider, suffix: 'btn'})}
		/>
		: <KeyboardArrowDownIcon
			sx={controlStyles}
			onClick={handlerOpen}
			id={generateTag(!open ? 'open' : 'close', {prefix: 'offer-card', snippet: props.offer.provider, suffix: 'btn'})}
		/>

	const isProviderLogoHidden = props.offer?.isLogoHidden? true : false
	const srcProvider = props.offer?.card?.logo ?? props.offer.locationAddress?.logoURL ?? getProviderLogo({provider: props.offer, isGray: props.type === 'expired'})
	const isOfferExpired = OfferHelper.isOfferExpired(props.offer)
	const isLocalDealer = (props.offer.provider === 'vincue' && !props.offer.locationAddress?.logoURL) || (props.offer['type'] === Types.IOC && !props.offer?.card?.logo) ? true : false
	
	let offerDetails = props?.offer?.card?.offerDetails

	const LogoBlock = ( props: {srcProvider: string|undefined, isProviderLogoHidden: boolean, isLocalDealer: boolean }) => {		
		if(isLocalDealer) {
			return <Box className="provider-logo" sx={{
				color: '#2A2F31',
				fontSize: '30px',
				lineHeight: '36px',
				fontWeight: 500,
			}}>{'Local Dealer'}</Box>
		}

		if(!!srcProvider && !isProviderLogoHidden) {
			return <Box component={'img'} src={srcProvider} className="provider-logo"/>
		}
		if(!srcProvider && !isProviderLogoHidden) {
			return <Box className="provider-logo"/>
		}
		if(isProviderLogoHidden) {
			return <Box className="provider-logo" sx={{
				color: '#2A2F31',
				fontSize: '30px',
				lineHeight: '36px',
				fontWeight: 500,
				textTransform: 'uppercase',
			}}>{`Offer A`}</Box>
		}
		return <></>
	}
	
	const SvgIconFromUrl = ({icon, width = 28, height = 28}: {icon: string, width?: number, height?: number}) => {
		// const [iconSrc, setIconSrc] = useState(icon)
		// useEffect(() => {
		// 	setIconSrc(icon)
		// }, [icon])
		
		return (
			<Icon style={{textAlign: 'center', width: `${width}px`, height: `${height}px`}}>
				<img src={icon} style={{display: 'flex', width: 'inherit', height: 'inherit'}}/>
			</Icon>
		)
	}
	
	const Badges = ({badges}: {badges: any}) => {
		let iconBadge: undefined | string
		let textBadge: undefined | string
		
		for (let key in badges) {
			if (['icon'].includes(key)) {
				continue
			}
			
			const badge = badges[key]
			
			if (badge.status) {
				iconBadge = badges.icon
				textBadge = badge.caption
				break
			}
		}
		
		if (iconBadge === undefined) {
			return null
		}
		
		if (textBadge === undefined) {
			return null
		}
		
		return (
			<Box className="toggle-badge">
				<SvgIconFromUrl icon={iconBadge}/>
				<span className={"text"}>{textBadge}</span>
			</Box>
		)
	}
	
	const getExpiresDate = (offer: any) => {
		if (isOfferExpired) {
			return `Expired`
		}
		
		if (offer.expiresAt) {
			return `Expires ${moment(offer.expiresAt).format('M/D/Y')}`
		}
		return null;
	}
	
	const expiresDate = getExpiresDate(props.offer);
	
	const FactElement = (benefit: any, index: number) => {
		return (
			<div className="fact-block-line" key={index}>
				<SvgIconFromUrl icon={benefit.icon}/>
				<div className="fact-text">{benefit.text}</div>
			</div>
		)
	}

	const CarvanaAffiliateProgramBlock = () => {
		const headerTitle = 'Carvana lets you sell or trade your car in just a few steps.';
		const headerDescription = 'Get an offer from Carvana in 2 minutes.';

		return (
			<>
				<Box sx={{
					textAlign: 'center',
					color: '#2A2F31',
				}}>
					<Box
						sx={{
							fontWeight: 700,
							fontSize: '22px',
							lineHeight: '22px',
							paddingTop: '8px',
							paddingBottom: '8px',
							mb: '10px',
						}}
						dangerouslySetInnerHTML={{__html: headerTitle}}
					/>
					<Box
						sx={{
							fontWeight: 400,
							fontSize: '14px',
							lineHeight: '20px',
						}}
					>{headerDescription}</Box>
				</Box>
			</>
		)
	}

	const HeaderBlock = ({offer, expiresDate}: {offer: any, expiresDate: any}) => {
		if (offer.isAffiliateProgram) {
			return (
				<CarvanaAffiliateProgramBlock/>
			)
		}

		return (
			<>
				<OfferAmount offer={offer} />
				<Box className="toggle-info">
					{
						OfferHelper.isOfferInProgress(offer)
							? (
								<Box className="toggle-text">
									<span>Offer is in-progress, a Carwiser Agent will reach out once it is generated</span>
								</Box>
							)
							: (
								<>
									<Badges badges={offer?.card?.badges}/>
									{
										expiresDate && (
											<Box className="toggle-expire information-block-line">
												<TimerOutlined sx={{color: '#E3342F'}}/>
												<div className="information-text red">{expiresDate}</div>
											</Box>
										)
									}
								</>
							)
					}
				</Box>
			</>
		)
	}

	const ButtonSubmit = props.offer.isAffiliateProgram
		? (
			<Button
				variant="contained"
				sx={{
					minWidth: '260px',
					fontSize: '22px',
					lineHeight: 1.5,
				}}
				id={props.offer?.case?.idSelector ?? generateTag('continue', {prefix: 'offer-card', snippet: props.offer.provider, suffix: 'btn'})}
				href={props.offer.case.url}
				target={'_blank'}
			>
				GET CARVANA OFFER
			</Button>)
		: (
			<Button
				onClick={onToOffer}
				disabled={!OfferHelper.canOpenOfferLink(props.offer) || props.loading}
				loading={isLoading}
				variant="contained"
				sx={{minWidth: '260px'}}
				id={generateTag('continue', {prefix: 'offer-card', snippet: props.offer.provider, suffix: 'btn'})}
			>
				CONTINUE
			</Button>
		)

	return (
		<Box className={'offer offer-block' + (open ? ' open' : '') + (isOfferExpired === true ? ' hide-toggle' : '') + OfferHelper.generateClass(props.offer)}>
			<Box className="details" onClick={handlerOpen} sx={{
				cursor: isOfferExpired === true ? 'inherit' : 'pointer'
			}}>
				<Box className="accordion-toggle">
					<Box className="ac-cont">
						<div className="toggle-text">DETAILS</div>
						<div className="toggle-icon">{control}</div>
					</Box>					
				</Box>
				<LogoBlock srcProvider={srcProvider} isLocalDealer={isLocalDealer} isProviderLogoHidden={isProviderLogoHidden} />
				<HeaderBlock offer={props.offer} expiresDate={expiresDate}/>
				{/* <OfferDetails offer={props.offer} /> */}
			</Box>
			<Collapse in={open}>
				<Box className={`expansion-panel` + OfferHelper.generateClass(props.offer, 'expansion-panel')}>
					<Box className={'main-details' + OfferHelper.generateClass(props.offer, 'main-details')}>
						<Box className={`description-block` + OfferHelper.generateClass(props.offer, 'benefits')}>
							<Box className="description-header">BENEFITS</Box>
							<Box className="facts-block">
								<Box className="facts-block-cont">
									{offerDetails?.benefits.map((el: any, index: number) => FactElement(el, index))}
								</Box>
							</Box>
						</Box>
						<Box className={`description-block` + OfferHelper.generateClass(props.offer, 'next-steps')}>
							<Box className="description-header">NEXT STEPS</Box>
							<Box className="icon-cols">
								{offerDetails?.nextSteps.map((el: any, index: number) => {
									const number = index + 1
									return (
										<Box key={index} className="icon-col">
											<Box className="icon">
												<SvgIconFromUrl icon={el.icon.src} width={40} height={40}/>
											</Box>
											<Box className="text">{`${number}. ${el.icon.caption}`}</Box>
										</Box>
									)
								})}
							</Box>
						</Box>
						<Box className={`description-block` + OfferHelper.generateClass(props.offer, 'documents')}>
							<Box className="description-header">DOCUMENTS YOU’LL NEED</Box>
							<Box className="icon-cols">
								{offerDetails?.documents.map((el: any, index: number) => {
									return (
										<Box key={index} className="icon-col">
											<Box className="icon">
												<SvgIconFromUrl icon={el.icon.src} width={40} height={40}/>
											</Box>
											<Box className="text">{el.icon.caption}</Box>
										</Box>
									)
								})}
							</Box>
						</Box>
					</Box>
					<Box sx={{display: 'flex', justifyContent: 'center'}}>
						{ButtonSubmit}
					</Box>
				</Box>
			</Collapse>
		</Box>
	)
}

const mapStateToProps = (state: RootState) => {
	return {
		loading: state.offers.loading,
	}
}

const mapDispatchToProps = (dispatch: any) => {
	return {
		selectOffer: (offer: Offer, cb: any) => dispatch(selectOffer(offer, cb)),
		setSelectedOffer: (offer: Offer) => dispatch(setSelectedOffer(offer)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(OfferComponent)